import type { StartRumEvent } from '@/types/logger.types'

const SHORTEST_REPORTED_EVENT_MS = 16
const PAINT_WAIT_LIMIT_MS = 500

function observeClickPaint(): Promise<void> {
    if (!PerformanceObserver.supportedEntryTypes.includes('event')) {
        return Promise.resolve()
    }

    let timeoutId: number | undefined

    return new Promise((resolve) => {
        function finish() {
            observer.disconnect()
            window.clearTimeout(timeoutId)
            resolve()
        }

        const observer = new PerformanceObserver((list) => {
            if (list.getEntriesByName('click').length) {
                finish()
            }
        })
        observer.observe({ type: 'event', durationThreshold: SHORTEST_REPORTED_EVENT_MS })

        timeoutId = window.setTimeout(finish, PAINT_WAIT_LIMIT_MS)
    })
}

export async function waitForClickPaint(startRumEvent: StartRumEvent): Promise<void> {
    const sendRumEvent = startRumEvent({ operationName: 'click-paint-wait' })

    try {
        await observeClickPaint()
        sendRumEvent({ status: 'success' })
    } catch (error) {
        sendRumEvent({ status: 'error', dimension1: String(error) })
    }
}
